import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ISms } from '../../../../models/request-and-responses/rest-api/interfaces/sms.interface';
import { DataService } from '../../../../services/data.service';
import { SuperadminModalComponent } from './modal/modal.component';

@Component({
    selector: 'app-superadmin-templates',
    templateUrl: './templates.component.html',
    styleUrls: ['./templates.component.css']
})
export class SuperadminTemplatesComponent implements OnInit {

    public templates: ISms[];
    public isLoading = false;

    constructor(
        private dataService: DataService,
        private modalService: NgbModal,
        private toastr: ToastrService
    ) {
    }
    ngOnInit() {

        this.initData();

    }

    async initData() {

        try {

            this.isLoading = true;

            this.templates = await this.dataService.getTemplates();

            this.isLoading = false;

        } catch (err) {

            this.toastr.error("Errore durante l'inizializzazione dei dati");

        }

    }

    async openModal(operation: string, id?: number) {

        try {

            const options: NgbModalOptions = {
                centered: true,
                size: 'lg',
                windowClass: 'modal-xxl',
                backdrop: 'static',
                keyboard: false
            };

            let modalRef;

            switch(operation) {

                case 'new':

                    modalRef = await this.modalService.open(SuperadminModalComponent, options);
                    modalRef.componentInstance.operation = 'new';
                    modalRef.componentInstance.title = 'Nuovo Template';

                    break;

                case 'edit':

                    modalRef = await this.modalService.open(SuperadminModalComponent, options);
                    modalRef.componentInstance.id = id;
                    modalRef.componentInstance.operation = 'edit';
                    modalRef.componentInstance.title = 'Dettaglio/Modifica Template';

                    break;
                
                case 'remove':

                    modalRef = await this.modalService.open(SuperadminModalComponent, options);
                    modalRef.componentInstance.id = id;
                    modalRef.componentInstance.operation = 'remove';
                    modalRef.componentInstance.title = 'Rimozione Template';

                    break;

                case 'link':

                    modalRef = await this.modalService.open(SuperadminModalComponent, options);
                    modalRef.componentInstance.id = id;
                    modalRef.componentInstance.operation = 'link';
                    modalRef.componentInstance.title = 'Associazione Template';

                    break;

                default:

            }

            modalRef.result.then((result) => {
                if (result) {
                    this.initData();
                }
            });

        } catch (err) {

            this.toastr.error("Errore durante il completamento dell'operazione");

        }

    }
}



// WEBPACK FOOTER //
// ./src/app/pages/role-specific/superadmin/templates/templates.component.ts